import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat-map";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context40; _forEachInstanceProperty(_context40 = ownKeys(Object(source), true)).call(_context40, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context41; _forEachInstanceProperty(_context41 = ownKeys(Object(source))).call(_context41, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-async-promise-executor */
import { useRef, useCallback, useMemo } from 'react';
import { useRecoilCallback } from 'recoil';
import flatten from 'flat';
import { isPromise, getValue, getIsDirty } from '../utils';
import { formAtom, formSelector } from '../react-forms';
import { get, set, uniq, noop, merge, mergeWith, cloneDeep, isFunction, isPlainObject } from 'lodash';

function useActions() {
  var blockSubmission = useRef(false);
  var setFormState = useRecoilCallback(function (_ref) {
    var recoilSet = _ref.set;
    return function (_ref2, update) {
      var groupId = _ref2.groupId,
          id = _ref2.id;

      if (isFunction(update)) {
        return recoilSet(formAtom({
          groupId: groupId,
          id: id
        }), update);
      }

      var names = update.names,
          initialValues = update.initialValues,
          values = _valuesInstanceProperty(update),
          touched = update.touched,
          isDirty = update.isDirty,
          isValidating = update.isValidating,
          errors = update.errors,
          meta = update.meta;

      return recoilSet(formAtom({
        groupId: groupId,
        id: id
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          names: getValue(names, prevForm.names),
          initialValues: getValue(initialValues, prevForm.initialValues),
          values: getValue(values, _valuesInstanceProperty(prevForm)),
          touched: getValue(touched, prevForm.touched),
          isDirty: getValue(isDirty, prevForm.isDirty),
          isValidating: getValue(isValidating, prevForm.isValidating),
          errors: getValue(errors, prevForm.errors),
          meta: getValue(meta, prevForm.meta)
        });
      });
    };
  }, []);
  var setFieldState = useRecoilCallback(function (_ref3) {
    var recoilSet = _ref3.set;
    return function (_ref4, update) {
      var groupId = _ref4.groupId,
          id = _ref4.id;

      if (isFunction(update)) {
        return recoilSet(formAtom({
          groupId: groupId,
          id: id
        }), update);
      }

      function setValue(prevState, nextState) {
        return nextState !== undefined ? set(cloneDeep(prevState), name, getValue(nextState, get(prevState, name))) : prevState;
      }

      var name = update.name,
          initialValue = update.initialValue,
          value = update.value,
          touched = update.touched,
          isValidating = update.isValidating,
          error = update.error;
      return recoilSet(formAtom({
        groupId: groupId,
        id: id
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          initialValues: setValue(prevForm.initialValues, initialValue),
          values: setValue(_valuesInstanceProperty(prevForm), value),
          touched: setValue(prevForm.touched, touched),
          // Derive isDirty state whenever
          // we set any other state
          isDirty: setValue(prevForm.isDirty, getIsDirty(name, getValue(initialValue, get(prevForm.initialValues, name)), getValue(value, get(_valuesInstanceProperty(prevForm), name)))),
          isValidating: setValue(prevForm.isValidating, isValidating),
          errors: setValue(prevForm.errors, error)
        });
      });
    };
  }, []);
  var setName = useRecoilCallback(function () {
    return function (_ref5, name) {
      var groupId = _ref5.groupId,
          id = _ref5.id;
      setFormState({
        groupId: groupId,
        id: id
      }, {
        names: function names(prevNames) {
          var _context;

          return uniq(_concatInstanceProperty(_context = []).call(_context, _toConsumableArray(prevNames), [name]));
        }
      });
    };
  }, [setFormState]);

  var _setFieldValue = useRecoilCallback(function () {
    return function (_ref6, name, value) {
      var groupId = _ref6.groupId,
          id = _ref6.id;
      setFieldState({
        groupId: groupId,
        id: id
      }, {
        name: name,
        value: value
      });
    };
  }, [setFieldState]);

  var _setValues = useRecoilCallback(function () {
    return function (_ref7, values) {
      var groupId = _ref7.groupId,
          id = _ref7.id;
      setFormState({
        groupId: groupId,
        id: id
      }, function (prevForm) {
        var _context2, _context3;

        var newValues = getValue(values, _valuesInstanceProperty(prevForm));
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          values: newValues,
          isDirty: _reduceInstanceProperty(_context2 = prevForm.names).call(_context2, function (acc, name) {
            return set(acc, name, getIsDirty(name, get(prevForm.initialValues, name), get(newValues, name)));
          }, {}),
          errors: _reduceInstanceProperty(_context3 = prevForm.names).call(_context3, function (acc, name) {
            if (get(newValues, name)) {
              return set(acc, name, null);
            }

            return acc;
          }, {})
        });
      });
    };
  }, [setFormState]);

  var _setFieldTouched = useRecoilCallback(function () {
    return function (_ref8, name, touched) {
      var groupId = _ref8.groupId,
          id = _ref8.id;
      setFieldState({
        groupId: groupId,
        id: id
      }, {
        name: name,
        touched: touched
      });
    };
  }, [setFieldState]);

  var _setTouched = useRecoilCallback(function () {
    return function (_ref9, newTouched) {
      var groupId = _ref9.groupId,
          id = _ref9.id;
      setFormState({
        groupId: groupId,
        id: id
      }, {
        touched: function touched(prevTouched) {
          return getValue(newTouched, prevTouched);
        }
      });
    };
  }, [setFormState]);

  var _setFieldError = useRecoilCallback(function () {
    return function (_ref10, name, error) {
      var groupId = _ref10.groupId,
          id = _ref10.id;
      setFieldState({
        groupId: groupId,
        id: id
      }, {
        name: name,
        error: error
      });
    };
  }, [setFieldState]);

  var _setErrors = useRecoilCallback(function () {
    return function (_ref11, newErrors) {
      var groupId = _ref11.groupId,
          id = _ref11.id;
      setFormState({
        groupId: groupId,
        id: id
      }, function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          errors: getValue(newErrors, prevForm.errors)
        });
      });
    };
  }, [setFormState]);

  var _setMeta = useRecoilCallback(function () {
    return function (_ref12, _meta) {
      var groupId = _ref12.groupId,
          id = _ref12.id;
      setFormState({
        groupId: groupId,
        id: id
      }, {
        meta: function meta(prevMeta) {
          return getValue(_meta, prevMeta);
        }
      });
    };
  }, [setFormState]);

  var _resetField = useRecoilCallback(function (_ref13) {
    var snapshot = _ref13.snapshot;
    return function (_ref14, name, value) {
      var groupId = _ref14.groupId,
          id = _ref14.id;
      var initialValues = snapshot.getLoadable(formAtom({
        groupId: groupId,
        id: id
      })).contents.initialValues;
      var newValue = getValue(value, getValue(get(initialValues, name), null));
      setFieldState({
        groupId: groupId,
        id: id
      }, {
        name: name,
        initialValue: newValue,
        value: newValue,
        touched: false,
        isValidating: false,
        error: null
      });
    };
  }, [setFieldState]);

  var _resetForm = useRecoilCallback(function () {
    return function (_ref15, values) {
      var groupId = _ref15.groupId,
          id = _ref15.id;
      setFormState({
        groupId: groupId,
        id: id
      }, function (prevForm) {
        var _context4, _context5, _context6, _context7;

        var newValues = getValue(values, prevForm.initialValues);
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          initialValues: newValues,
          values: newValues,
          touched: _reduceInstanceProperty(_context4 = prevForm.names).call(_context4, function (acc, name) {
            return set(acc, name, false);
          }, {}),
          isDirty: _reduceInstanceProperty(_context5 = prevForm.names).call(_context5, function (acc, name) {
            return set(acc, name, false);
          }, {}),
          isValidating: _reduceInstanceProperty(_context6 = prevForm.names).call(_context6, function (acc, name) {
            return set(acc, name, false);
          }, {}),
          errors: _reduceInstanceProperty(_context7 = prevForm.names).call(_context7, function (acc, name) {
            return set(acc, name, null);
          }, {})
        });
      });
    };
  }, [setFormState]);

  var baseActions = useMemo(function () {
    return {
      setName: setName,
      setFieldValue: _setFieldValue,
      setValues: _setValues,
      setFieldTouched: _setFieldTouched,
      setTouched: _setTouched,
      setFieldError: _setFieldError,
      setErrors: _setErrors,
      setMeta: _setMeta,
      resetField: _resetField,
      resetForm: _resetForm
    };
  }, [setName, _setFieldValue, _setValues, _setFieldTouched, _setTouched, _setFieldError, _setErrors, _setMeta, _resetField, _resetForm]);
  var createHelpers = useCallback(function (_ref16) {
    var groupId = _ref16.groupId,
        id = _ref16.id;
    return {
      setFieldValue: function setFieldValue() {
        var _context8;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _setFieldValue.apply(void 0, _concatInstanceProperty(_context8 = [{
          groupId: groupId,
          id: id
        }]).call(_context8, args));
      },
      setValues: function setValues() {
        var _context9;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _setValues.apply(void 0, _concatInstanceProperty(_context9 = [{
          groupId: groupId,
          id: id
        }]).call(_context9, args));
      },
      setFieldTouched: function setFieldTouched() {
        var _context10;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return _setFieldTouched.apply(void 0, _concatInstanceProperty(_context10 = [{
          groupId: groupId,
          id: id
        }]).call(_context10, args));
      },
      setTouched: function setTouched() {
        var _context11;

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return _setTouched.apply(void 0, _concatInstanceProperty(_context11 = [{
          groupId: groupId,
          id: id
        }]).call(_context11, args));
      },
      setFieldError: function setFieldError() {
        var _context12;

        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        return _setFieldError.apply(void 0, _concatInstanceProperty(_context12 = [{
          groupId: groupId,
          id: id
        }]).call(_context12, args));
      },
      setMeta: function setMeta() {
        var _context13;

        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        return _setMeta.apply(void 0, _concatInstanceProperty(_context13 = [{
          groupId: groupId,
          id: id
        }]).call(_context13, args));
      },
      setErrors: function setErrors() {
        var _context14;

        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }

        return _setErrors.apply(void 0, _concatInstanceProperty(_context14 = [{
          groupId: groupId,
          id: id
        }]).call(_context14, args));
      },
      resetField: function resetField() {
        var _context15;

        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }

        return _resetField.apply(void 0, _concatInstanceProperty(_context15 = [{
          groupId: groupId,
          id: id
        }]).call(_context15, args));
      },
      resetForm: function resetForm() {
        var _context16;

        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }

        return _resetForm.apply(void 0, _concatInstanceProperty(_context16 = [{
          groupId: groupId,
          id: id
        }]).call(_context16, args));
      }
    };
  }, [_setFieldValue, _setValues, _setFieldTouched, _setTouched, _setFieldError, _setMeta, _setErrors, _resetField, _resetForm]);
  var validateField = useRecoilCallback(function (_ref17) {
    var snapshot = _ref17.snapshot;
    return /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref18, name, value) {
        var groupId, id, validate, state, values, allValues, helpers, validationHelper, _context17, formErrors, validator, fieldError;

        return _regeneratorRuntime.wrap(function _callee$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                groupId = _ref18.groupId, id = _ref18.id, validate = _ref18.validate;
                state = snapshot.getLoadable(formSelector({
                  groupId: groupId,
                  id: id
                })).contents;
                values = _valuesInstanceProperty(state); // The snapshot gets state of the current
                // transaction from the start of the callback
                // that it's called from - this means that
                // in useField where we try to set the form
                // state and then validate the value,
                // in the snapshot it is out of date

                value = getValue(value, get(values, name));
                allValues = set(cloneDeep(_valuesInstanceProperty(state)), name, value);
                helpers = createHelpers({
                  groupId: groupId,
                  id: id
                });
                validationHelper = _objectSpread(_objectSpread(_objectSpread({}, state), helpers), {}, {
                  values: allValues
                });
                _context18.prev = 7;
                setFieldState({
                  groupId: groupId,
                  id: id
                }, {
                  name: name,
                  isValidating: true
                });

                if (!isFunction(validate)) {
                  _context18.next = 17;
                  break;
                }

                _context18.next = 12;
                return validate(allValues, validationHelper);

              case 12:
                formErrors = _context18.sent;

                _forEachInstanceProperty(_context17 = _Object$keys(state.touched)).call(_context17, function (fieldName) {
                  setFieldState({
                    groupId: groupId,
                    id: id
                  }, {
                    name: fieldName,
                    error: get(formErrors, fieldName, null)
                  });
                });

                return _context18.abrupt("return", get(formErrors, name));

              case 17:
                if (!isPlainObject(validate)) {
                  _context18.next = 26;
                  break;
                }

                // If we receive a plain object then each field has it's own validate
                // function so we don't have to wait for async validation to finish
                // before we can display our sync errors
                validator = get(validate, name);

                if (!isFunction(validator)) {
                  _context18.next = 26;
                  break;
                }

                _context18.next = 22;
                return validator(allValues, validationHelper);

              case 22:
                fieldError = _context18.sent;

                if (!fieldError) {
                  _context18.next = 26;
                  break;
                }

                setFieldState({
                  groupId: groupId,
                  id: id
                }, {
                  name: name,
                  error: fieldError
                });
                return _context18.abrupt("return", fieldError);

              case 26:
                setFieldState({
                  groupId: groupId,
                  id: id
                }, {
                  name: name,
                  error: null
                });
                return _context18.abrupt("return", null);

              case 28:
                _context18.prev = 28;
                setFieldState({
                  groupId: groupId,
                  id: id
                }, {
                  name: name,
                  isValidating: false
                });
                return _context18.finish(28);

              case 31:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee, null, [[7,, 28, 31]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref19.apply(this, arguments);
      };
    }();
  }, [createHelpers, setFieldState]);
  var validateForms = useRecoilCallback( // Should be in the shape { [formId]: { validate } }
  function (_ref20) {
    var snapshot = _ref20.snapshot;
    return /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref21, formConfigs) {
        var groupId, increaseSubmitCount, allErrors, errorPromises, _context19, _context22, _context23, promiseCollection, _context28, asyncErrors, _context29;

        return _regeneratorRuntime.wrap(function _callee5$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                groupId = _ref21.groupId, increaseSubmitCount = _ref21.increaseSubmitCount;
                allErrors = {};
                errorPromises = {};
                _context31.prev = 3;

                _forEachInstanceProperty(_context19 = _Object$keys(formConfigs)).call(_context19, function (id) {
                  var _formConfigs$id;

                  // Set all field touched and isValidating to true
                  setFormState({
                    groupId: groupId,
                    id: id
                  }, function (prevForm) {
                    var _context20;

                    return _objectSpread(_objectSpread({}, prevForm), {}, {
                      submitCount: increaseSubmitCount ? prevForm.submitCount + 1 : prevForm.submitCount,
                      isValidating: _reduceInstanceProperty(_context20 = prevForm.names).call(_context20, function (acc, name) {
                        return set(acc, name, true);
                      }, {})
                    });
                  });
                  var validate = (_formConfigs$id = formConfigs[id]) === null || _formConfigs$id === void 0 ? void 0 : _formConfigs$id.validate;
                  var state = snapshot.getLoadable(formSelector({
                    groupId: groupId,
                    id: id
                  })).contents;

                  var values = _valuesInstanceProperty(state);

                  var helpers = createHelpers({
                    groupId: groupId,
                    id: id
                  });

                  var validationHelper = _objectSpread(_objectSpread({}, state), helpers);

                  if (isFunction(validate)) {
                    var formErrors = validate(values, validationHelper);

                    if (isPromise(formErrors)) {
                      errorPromises[id] = formErrors;
                    } else {
                      allErrors[id] = formErrors;
                    }
                  } else if (isPlainObject(validate)) {
                    var _context21;

                    var flatValidate = flatten(validate);

                    _forEachInstanceProperty(_context21 = _Object$keys(flatValidate)).call(_context21, function (name) {
                      var fieldError = flatValidate[name](values, validationHelper);

                      if (isPromise(fieldError)) {
                        errorPromises[id] = _objectSpread(_objectSpread({}, errorPromises[id]), {}, _defineProperty({}, name, fieldError));
                      } else {
                        allErrors[id] = set(_objectSpread({}, allErrors[id]), name, fieldError);
                      }
                    });
                  }
                });

                _forEachInstanceProperty(_context22 = _Object$keys(allErrors)).call(_context22, function (id) {
                  _setErrors({
                    groupId: groupId,
                    id: id
                  }, function (prevErrors) {
                    return merge({}, prevErrors, allErrors[id]);
                  });
                }); // TODO: Clean this up a bit
                // Currently what it does is
                // take all of the promises that
                // are returned from either our
                // validate function or validate object
                // and resolves the promises + maps
                // to the same shape as the syncErrors


                promiseCollection = _flatMapInstanceProperty(_context23 = _Object$keys(errorPromises)).call(_context23, function (id) {
                  if (isPromise(errorPromises[id])) {
                    return new _Promise( /*#__PURE__*/function () {
                      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
                        var errors;
                        return _regeneratorRuntime.wrap(function _callee2$(_context24) {
                          while (1) {
                            switch (_context24.prev = _context24.next) {
                              case 0:
                                _context24.prev = 0;
                                _context24.next = 3;
                                return errorPromises[id];

                              case 3:
                                errors = _context24.sent;
                                resolve(_defineProperty({}, id, errors));
                                _context24.next = 10;
                                break;

                              case 7:
                                _context24.prev = 7;
                                _context24.t0 = _context24["catch"](0);
                                reject(_context24.t0);

                              case 10:
                              case "end":
                                return _context24.stop();
                            }
                          }
                        }, _callee2, null, [[0, 7]]);
                      }));

                      return function (_x6, _x7) {
                        return _ref23.apply(this, arguments);
                      };
                    }());
                  }

                  return new _Promise( /*#__PURE__*/function () {
                    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve, reject) {
                      var _context25, flatErrorPromises, fieldErrorPromises, fieldErrors;

                      return _regeneratorRuntime.wrap(function _callee4$(_context27) {
                        while (1) {
                          switch (_context27.prev = _context27.next) {
                            case 0:
                              _context27.prev = 0;
                              flatErrorPromises = flatten(errorPromises[id]);
                              fieldErrorPromises = _mapInstanceProperty(_context25 = _Object$keys(flatErrorPromises)).call(_context25, function (name) {
                                return new _Promise( /*#__PURE__*/function () {
                                  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
                                    var error;
                                    return _regeneratorRuntime.wrap(function _callee3$(_context26) {
                                      while (1) {
                                        switch (_context26.prev = _context26.next) {
                                          case 0:
                                            _context26.prev = 0;
                                            _context26.next = 3;
                                            return flatErrorPromises[name];

                                          case 3:
                                            error = _context26.sent;
                                            resolve(set({}, name, error));
                                            _context26.next = 10;
                                            break;

                                          case 7:
                                            _context26.prev = 7;
                                            _context26.t0 = _context26["catch"](0);
                                            reject(_context26.t0);

                                          case 10:
                                          case "end":
                                            return _context26.stop();
                                        }
                                      }
                                    }, _callee3, null, [[0, 7]]);
                                  }));

                                  return function (_x10, _x11) {
                                    return _ref25.apply(this, arguments);
                                  };
                                }());
                              });
                              _context27.next = 5;
                              return _Promise.all(fieldErrorPromises);

                            case 5:
                              fieldErrors = _context27.sent;
                              resolve(_defineProperty({}, id, _reduceInstanceProperty(fieldErrors).call(fieldErrors, function (acc, field) {
                                return merge(acc, field);
                              }, {})));
                              _context27.next = 12;
                              break;

                            case 9:
                              _context27.prev = 9;
                              _context27.t0 = _context27["catch"](0);
                              reject(_context27.t0);

                            case 12:
                            case "end":
                              return _context27.stop();
                          }
                        }
                      }, _callee4, null, [[0, 9]]);
                    }));

                    return function (_x8, _x9) {
                      return _ref24.apply(this, arguments);
                    };
                  }());
                });

                if (!(promiseCollection.length > 0)) {
                  _context31.next = 13;
                  break;
                }

                _context31.next = 10;
                return _Promise.all(promiseCollection);

              case 10:
                asyncErrors = _context31.sent;
                allErrors = mergeWith({}, allErrors, _reduceInstanceProperty(asyncErrors).call(asyncErrors, function (acc, fields) {
                  return merge(acc, fields);
                }, {}), function (sError, asError) {
                  // Make sure null async errors don't
                  // squash our sync errors
                  if (asError === null && sError !== null) {
                    return sError;
                  }
                });

                _forEachInstanceProperty(_context28 = _Object$keys(allErrors)).call(_context28, function (id) {
                  _setErrors({
                    groupId: groupId,
                    id: id
                  }, function (prevErrors) {
                    return merge({}, prevErrors, allErrors[id]);
                  });
                });

              case 13:
                return _context31.abrupt("return", allErrors);

              case 14:
                _context31.prev = 14;

                _forEachInstanceProperty(_context29 = _Object$keys(formConfigs)).call(_context29, function (id) {
                  // Set all field isValidating to false
                  setFormState({
                    groupId: groupId,
                    id: id
                  }, function (prevForm) {
                    var _context30;

                    return _objectSpread(_objectSpread({}, prevForm), {}, {
                      isValidating: _reduceInstanceProperty(_context30 = prevForm.names).call(_context30, function (acc, name) {
                        return set(acc, name, false);
                      }, {})
                    });
                  });
                });

                return _context31.finish(14);

              case 17:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee5, null, [[3,, 14, 17]]);
      }));

      return function (_x4, _x5) {
        return _ref22.apply(this, arguments);
      };
    }();
  }, [createHelpers, setFormState, _setErrors]);
  var submitForms = useRecoilCallback( // Should be in the shape { [formId]: { validate, handleSubmit } }
  function (_ref26) {
    var snapshot = _ref26.snapshot;
    return /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref27, formConfigs) {
        var groupId,
            _ref29,
            _ref29$shouldReset,
            shouldReset,
            _ref29$onValidationFa,
            onValidationFail,
            allErrors,
            allValues,
            allSubmissions,
            submissionPromises,
            _context32,
            _context33,
            _context35,
            hasInvalid,
            id,
            handleSubmit,
            state,
            values,
            helpers,
            submissionHelper,
            submit,
            promiseCollection,
            asyncSubmissions,
            _context37,
            _context38,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                groupId = _ref27.groupId;
                _ref29 = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {}, _ref29$shouldReset = _ref29.shouldReset, shouldReset = _ref29$shouldReset === void 0 ? true : _ref29$shouldReset, _ref29$onValidationFa = _ref29.onValidationFail, onValidationFail = _ref29$onValidationFa === void 0 ? noop : _ref29$onValidationFa;
                allErrors = {};
                allValues = {};
                allSubmissions = {};
                submissionPromises = {};
                _context39.prev = 6;

                _forEachInstanceProperty(_context32 = _Object$keys(formConfigs)).call(_context32, function (id) {
                  setFormState({
                    groupId: groupId,
                    id: id
                  }, function (prevForm) {
                    return _objectSpread(_objectSpread({}, prevForm), {}, {
                      isSubmitting: true,
                      submitCount: prevForm.submitCount + 1
                    });
                  });
                  allSubmissions[id] = false;
                });

                if (!blockSubmission.current) {
                  _context39.next = 10;
                  break;
                }

                return _context39.abrupt("return", allSubmissions);

              case 10:
                blockSubmission.current = true;
                _context39.next = 13;
                return validateForms({
                  groupId: groupId
                }, formConfigs);

              case 13:
                allErrors = _context39.sent;
                hasInvalid = _someInstanceProperty(_context33 = _Object$keys(allErrors)).call(_context33, function (formId) {
                  var _context34;

                  var flatAllErrors = flatten(allErrors[formId]);
                  return _someInstanceProperty(_context34 = _Object$keys(flatAllErrors)).call(_context34, function (name) {
                    return get(flatAllErrors, name) !== null;
                  });
                });

                if (!hasInvalid) {
                  _context39.next = 19;
                  break;
                }

                // If this is the only form in the config
                // then we want to return just the form object
                // and not key this form by ID
                if (_Object$keys(allErrors).length === 1) {
                  allErrors = allErrors[_Object$keys(allErrors)[0]];
                }

                onValidationFail(allErrors);
                return _context39.abrupt("return", allSubmissions);

              case 19:
                for (id in formConfigs) {
                  handleSubmit = formConfigs[id].handleSubmit;
                  state = snapshot.getLoadable(formSelector({
                    groupId: groupId,
                    id: id
                  })).contents;
                  values = _valuesInstanceProperty(state);
                  allValues[id] = values;
                  helpers = createHelpers({
                    groupId: groupId,
                    id: id
                  });
                  submissionHelper = _objectSpread(_objectSpread({}, state), helpers);
                  submit = handleSubmit(values, submissionHelper);

                  if (isPromise(submit)) {
                    submissionPromises[id] = submit;
                  } else {
                    allSubmissions[id] = submit;
                  }
                }

                promiseCollection = _flatMapInstanceProperty(_context35 = _Object$keys(submissionPromises)).call(_context35, function (id) {
                  return new _Promise( /*#__PURE__*/function () {
                    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolve, reject) {
                      var submission;
                      return _regeneratorRuntime.wrap(function _callee6$(_context36) {
                        while (1) {
                          switch (_context36.prev = _context36.next) {
                            case 0:
                              _context36.prev = 0;
                              _context36.next = 3;
                              return submissionPromises[id];

                            case 3:
                              submission = _context36.sent;
                              resolve(_defineProperty({}, id, submission));
                              _context36.next = 10;
                              break;

                            case 7:
                              _context36.prev = 7;
                              _context36.t0 = _context36["catch"](0);
                              reject(_context36.t0);

                            case 10:
                            case "end":
                              return _context36.stop();
                          }
                        }
                      }, _callee6, null, [[0, 7]]);
                    }));

                    return function (_x14, _x15) {
                      return _ref30.apply(this, arguments);
                    };
                  }());
                });

                if (!(promiseCollection.length > 0)) {
                  _context39.next = 26;
                  break;
                }

                _context39.next = 24;
                return _Promise.all(promiseCollection);

              case 24:
                asyncSubmissions = _context39.sent;
                allSubmissions = merge({}, allSubmissions, _reduceInstanceProperty(asyncSubmissions).call(asyncSubmissions, function (acc, submission) {
                  return merge(acc, submission);
                }, {}));

              case 26:
                if (shouldReset) {
                  _forEachInstanceProperty(_context37 = _Object$keys(allSubmissions)).call(_context37, function (id) {
                    // If form submits successfully then reset
                    if (allSubmissions[id]) _resetForm({
                      groupId: groupId,
                      id: id
                    }, allValues[id]);
                  });
                }

                return _context39.abrupt("return", allSubmissions);

              case 28:
                _context39.prev = 28;

                _forEachInstanceProperty(_context38 = _Object$keys(formConfigs)).call(_context38, function (id) {
                  setFormState({
                    groupId: groupId,
                    id: id
                  }, function (prevForm) {
                    return _objectSpread(_objectSpread({}, prevForm), {}, {
                      isSubmitting: false
                    });
                  });
                });

                blockSubmission.current = false;
                return _context39.finish(28);

              case 32:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee7, null, [[6,, 28, 32]]);
      }));

      return function (_x12, _x13) {
        return _ref28.apply(this, arguments);
      };
    }();
  }, [createHelpers, setFormState, validateForms, _resetForm]);
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, baseActions), {}, {
      createHelpers: createHelpers,
      validateField: validateField,
      validateForms: validateForms,
      submitForms: submitForms
    });
  }, [baseActions, createHelpers, validateField, validateForms, submitForms]);
}

export { useActions };